import React from 'react';

import BrandfolderLogoHoriz from '@assets/images/Brandfolder_logo.png';

import './styles/footer';


const Footer = () => (
  <div className="footer-component">
    <div className="footer-component__left">
      <div className="copyright-container">
        <p className="copyright-text">
          ©{(new Date()).getFullYear()} Brandfolder, Inc.
        </p>
      </div>
      <div className="links-container">
        <a
          href="https://brandfolder.com/agreement/#!texts/xpxac06k"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('Privacy Policy')}
        </a>
        <p className="dot">·</p>
        <a
          href="https://brandfolder.com/agreement/#!texts/14negh88"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('Terms of Service')}
        </a>
      </div>
    </div>
    <div className="footer-component__right">
      <a
        className="bf-logo-container"
        href="https://brandfolder.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>{t('Powered by')}</span>
        <img className="bf-logo-horiz" src={BrandfolderLogoHoriz} alt="branfolder logo" />
      </a>
    </div>
  </div>
);

export default Footer;
